import { useEffect, useState } from 'react';

import { useFeatureServices } from './use-feature-services';

export function useDisclaimerReference(
  disclaimerText: string | undefined,
): string | undefined {
  const featureServices = useFeatureServices();
  const disclaimerManagerService = featureServices['disclaimer-manager'];

  const [disclaimerReference, setDisclaimerReference] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (!disclaimerText || !disclaimerManagerService) {
      setDisclaimerReference(undefined);
      return;
    }

    const disclaimerManager =
      disclaimerManagerService.getScopedDisclaimerManager();

    const registeredDisclaimerReference =
      disclaimerManager.registerReferenceDisclaimer(
        'module-reference',
        disclaimerText,
      );

    setDisclaimerReference(registeredDisclaimerReference);

    return () => {
      disclaimerManager.unregisterReferenceDisclaimer(
        'module-reference',
        disclaimerText,
      );
    };
  }, [disclaimerText, disclaimerManagerService]);

  return disclaimerReference;
}
